export default "__VITE_ASSET__D5G5Si6f__"